// extracted by css-extract-rspack-plugin
export default {"ListItemContainer":"ListItem-module__ListItemContainer__eHDg1jF","ListItemText":"ListItem-module__ListItemText__h8ZFyeW"};